import React from 'react';

function EyeIcon({ visible }) {
  return visible ? (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  ) : (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
      <line x1="1" y1="1" x2="23" y2="23" />
    </svg>
  );
}

function SpecificSkillExpertResponseCard({
  t,
  responseText = '',
  revealed = false,
  onToggle,
  showComplexReflectionHint = false,
}) {
  const showHint = revealed && showComplexReflectionHint;

  return (
    <div className={showHint ? 'oars-next-exercise-wrap oars-expert-response-wrap' : undefined}>
      <div className="analytics-card">
        <div className="analytics-card-header">
          <h5 className="analytics-card-title">{t('report_card_expert_response')}</h5>
          {responseText && (
            <button
              type="button"
              className={`analytics-toggle-icon ${revealed ? 'on' : 'off'}`}
              onClick={onToggle}
              role="switch"
              aria-checked={revealed}
              aria-label={revealed ? t('report_expert_hide_aria') : t('report_expert_reveal_title')}
              title={revealed ? t('report_expert_hide_title') : t('report_expert_reveal_title')}
            >
              <EyeIcon visible={revealed} />
            </button>
          )}
        </div>
        <div className="analytics-card-content">
          {!responseText ? (
            <p className="analytics-empty">{t('report_expert_empty')}</p>
          ) : revealed ? (
            <p className="analytics-text">{responseText}</p>
          ) : (
            <p className="analytics-empty">{t('report_expert_hidden_msg')}</p>
          )}
        </div>
      </div>
      {showHint && (
        <div className="oars-next-exercise-tooltip" role="status">
          This is one of many possible complex reflection types.
        </div>
      )}
    </div>
  );
}

export default SpecificSkillExpertResponseCard;
